<template>
    <div
        v-if="isShowModal"
        :style="styles"
        class="o-info-modal-sk"
        @click.self="closeModal"
    >
        <div class="info-modal-sk-container">
            <OInfoModalSKHeader
                :label="config.label"
                :description="config.description"
                @closeModal="closeModal"
            />
            <component :is="config.component" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OScheduleSK from '../o-schedule-sk';
import OMobileMapQr from '../o-mobile-map-qr';
import OInfoModalSKHeader from '../o-info-modal-sk-header';

import { EVENTS } from "@/utils/constants/bus-events-constants";
export default {
    name: 'OSInfoModalSK',
    components: {
        OScheduleSK,
        OMobileMapQr,
        OInfoModalSKHeader
    },
    data() {
        return {
            isShowModal: false,
            config: {},
            view: null
        }
    },
    mounted() {
        this.initListeners();
    },
    beforeDestroy() {
        this.removeListeners();
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        commonConfigParams() {
            return this.getMapConfigProp('components.OSInfoModalSK.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.footer.OSInfoModalSK.params`) || {};
        },
        params() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OSInfoModalSK.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.footer.OSInfoModalSK.styles`) || {};
        },
        styles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
    },
    methods: {
        initListeners() {
            this.$bus.$on(EVENTS.MODALS.INIT_INFO_MODAL, this.setData);
            this.$bus.$on(EVENTS.MODALS.OFF_INFO_MODAL, this.closeModal);
        },
        removeListeners() {
            this.$bus.$off(EVENTS.MODALS.INIT_INFO_MODAL, this.setData);
            this.$bus.$off(EVENTS.MODALS.OFF_INFO_MODAL, this.closeModal);
        },
        setData(data, view) {
            this.config = {
                ...this.config,
                ...data
            }
            this.view = view;
            this.openModal();
        },
        openModal() {
            this.isShowModal = true;
        },
        closeModal() {
            this.isShowModal = false;
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>
